const Button = ({ newQuote }) => {
  return <button onClick={() => newQuote()}>New Quote</button>;
};

export default Button;
